import GetPricingMapper from '@/modules/life/rater/mappers/MID/GetPricingMapper'
import SaveDocumentMapper from '@/modules/common/hiring/mappers/MID/SaveDocumentMapper'
import SaveQuotationMapper from '@/modules/common/common/mappers/MID/SaveQuotationMapper'
import GetRecoveryMapper from '@/modules/life/hiring/mappers/MID/GetRecoveryMapper'
import SavePolicyHolderMapper from '@/modules/life/hiring/mappers/MID/SavePolicyHolderMapper'
import SaveInsuredMapper from '@/modules/life/hiring/mappers/MID/SaveInsuredMapper'
import SaveQuestionnaireMapper from '@/modules/life/hiring/mappers/MID/SaveQuestionnaireMapper'
import SaveBeneficiariesMapper from '@/modules/life/hiring/mappers/MID/SaveBeneficiariesMapper'

export default {
  GetPricingMapper,
  SaveDocumentMapper,
  SaveQuotationMapper,
  GetRecoveryMapper,
  SavePolicyHolderMapper,
  SaveInsuredMapper,
  SaveQuestionnaireMapper,
  SaveBeneficiariesMapper
}
